module.exports = __webpack_public_path__ + "img/message-order@3x.c424447c.png";